var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "activities-page" } },
    [
      _c("ActivitySidebar", {
        attrs: { filter: _vm.filter },
        on: { filtered: _vm.updateFilters },
      }),
      _vm._v(" "),
      _c("div", { ref: "container", staticClass: "page-content" }, [
        _c(
          "div",
          { staticClass: "page-content-wrapper" },
          [
            _c("header", [_vm._v(_vm._s(_vm.$t("notification.activities")))]),
            _vm._v(" "),
            _c("ActivityListView", {
              attrs: { activities: _vm.activities, loading: _vm.loading },
              on: { "load-more": _vm.loadMore },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }